import { createAttachmentApi } from "../../../components/lifecycle/createAttachmentApi";

export const counterpartyAttachmentApi = createAttachmentApi({
  listKey: (entityId, lifecycleName) =>
    ["attachments", entityId, lifecycleName] as const,
  list: (client, { entityId, lifecycleName }) =>
    client.listAttachments.listAttachments({
      counterpartyId: entityId,
      lifecycleName
    }),
  download: (client, { entityId, lifecycleName, fileName }) =>
    client.downloadAttachment.downloadAttachment(
      { counterpartyId: entityId, lifecycleName, fileName },
      { format: "blob" }
    ),
  delete: (client, { entityId, lifecycleName, fileName }) =>
    client.deleteAttachment.deleteAttachment({
      counterpartyId: entityId,
      lifecycleName,
      fileName
    }),
  upload: { path: "/UploadAttachment", idParameter: "counterpartyId" }
});
